import "./Footer.css";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <span className="footer-copy">© {new Date().getFullYear()} Aflax</span>
      </div>
    </footer>
  );
}

export default Footer;
